import { render, staticRenderFns } from "./orderRaking.vue?vue&type=template&id=9b16cb7a&scoped=true&"
import script from "./orderRaking.vue?vue&type=script&lang=js&"
export * from "./orderRaking.vue?vue&type=script&lang=js&"
import style0 from "./orderRaking.vue?vue&type=style&index=0&id=9b16cb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b16cb7a",
  null
  
)

export default component.exports